import Link from "next/link";
import MediaComponent from "@core/helpers/server/components/image";

export function CategoryCard({ item, storage_prefix_url }) {

    return (
        <Link
            href={item?.seo?.full_url || "#"}
            className="group flex flex-col items-center justify-center w-full pt-2 space-y-4"
            style={{ minWidth: 0 }}
        >
            <div className="w-full flex justify-center">
                <div className="relative flex items-center justify-center w-[57px] h-[57px] lg:w-20 lg:h-20 bg-jmt-neutral-100 border border-jmt-neutral-200 rounded-md">
                    <div className="absolute w-[72px] h-[72px] lg:w-[100px] lg:h-[100px]">
                        {item?.media?.url?.length > 0 ?
                            <MediaComponent
                                src={item?.media?.url || ""}
                                alt={item?.media?.alt || item?.media?.title}
                                width={100}
                                height={100}
                                storage_prefix_url={storage_prefix_url}
                                style={{ width: "100%", height: "100%" }}
                                image_className="w-full h-full object-cover"
                            /> : <></>}

                    </div>

                </div>
            </div>


            {/* Title */}
            <span className="text-xs font-bold text-jmt-neutral-700 text-center whitespace-nowrap">
                {item?.title}
            </span>
        </Link>
    );
}


export const CategorySkeleton = () => (
    <div className="w-full flex flex-col items-center justify-center rounded-md overflow-hidden">


        <div className="lg:w-[100px] w-[72px] aspect-square bg-jmt-neutral-100 rounded-md overflow-hidden mb-2" />
        <div className="w-20 h-4.5 bg-jmt-neutral-100 rounded-md overflow-hidden" />
    </div>
);